import React, { Component } from 'react';
import { Redirect,Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {format as stringFormat} from 'react-string-format';

import {URL_IMG} from '../../configs/urlConfigs';
import { MSG_REQUIRED, MSG_NOT_FOUND, MSG_OTHER_EXP_ADD_SUCCESS, MSG_OTHER_EXP_UPDATE_SUCCESS, MSG_OTHER_EXP_DELETE_SUCCESS, MSG_OTHER_EXP_USED, MSG_OTHER_SAVE_FAILED} from '../../configs/msgConfigs';
import {LBL_ADD_NEW,LBL_APP_NAME, LBL_SETTINGS,LBL_OTHER_EXPENSES,LBL_SHORT_DESCRIPTION,LBL_ACTIONS, LBL_SLNUM, LBL_DELETE,LBL_EDIT,LBL_ARE_YOU_SURE_DELETE_OTHEXP,LBL_CONFIRM_DELETE,LBL_BACK_TO_SETTINGS} from '../../configs/labelConfigs'; 
import {ROUTE_REFRESH,ROUTE_AFFILIATE_REFRESH,LOGIN_AFFILIATE_GROUP,ROUTE_SA_SETTINGS, ROUTE_AFFILIATE_SETTINGS} from '../../configs/staticConfigs';

import ModalWindow from '../commons/helpers/modalWindow';
import Toast from '../commons/helpers/toast';

import {userGroupUrlCheck} from '../../utils/userGroupUrlCheck';
import {formValid} from '../../utils/validation';
import {getSortClass} from '../../utils/commonUtilities'; 

import * as types from '../../actions'; 
import {otherExpListAction, otherExpAddAction, otherExpEditAction, otherExpUpdateAction, otherExpDeleteAction} from '../../actions/settings/otherExpActions';
import {clearAction} from '../../actions/commonActions';

class OtherExpensesComponent extends Component { 

    constructor(props){
        super()

        this.state = {
            activeRowId:0,            
            formErrors:{
                otherExpName: MSG_REQUIRED,
                shortDescription: "",
            },          
            otherExpData:{
                otherExpId:'',
                otherExpName: null,               
                shortDescription: '',               
            },
            sortField:'name',
            sortOrder:'',
            toastMessage:'',
            toastFlag:false,
            toastSuccess:true,
        }
        this.openModal = this.openModal.bind(this);
        this.onSaveFormData = this.onSaveFormData.bind(this);
        this.onShowActionButtons = this.onShowActionButtons.bind(this);
        this.onHideActionButtons = this.onHideActionButtons.bind(this);
        this.onHandleChange = this.onHandleChange.bind(this);
        this.onSort = this.onSort.bind(this);

        this.modalDelete = React.createRef();
        this.modal       = React.createRef();
    }
  
    openModal() {
        let formErrors = this.state.formErrors;
        formErrors.otherExpName = MSG_REQUIRED;
        this.setState({formErrors});
        this.modal.current.handleOpenModal();
    }  

    onModalFormReset = () =>{       
        this.setState({otherExpData:{
            otherExpId:'',
            otherExpName:null,
            shortDescription:'',
        }});              
    }

    onHandleChange = (event) =>{
        const {name, value} = event.target;

        let formErrors     = this.state.formErrors;
        let trimmedValue   = value.trim();
        switch(name){
            case 'otherExpName':
                formErrors.otherExpName = 
                trimmedValue.length <=0 
                ? MSG_REQUIRED
                : ""
                break;            
            default :
            break;
        }

        let otherExpData   = this.state.otherExpData;
        otherExpData[name] = value;

        this.setState({formErrors,otherExpData});

    }

    onShowActionButtons = (event, rowId) =>{

        let dropdown     = document.getElementById('dropdown-'+rowId);
        let dropdownMenu = document.getElementById('dropdown-menu-'+rowId);
        dropdown.classList.toggle('show');
        dropdownMenu.classList.toggle('show');      

        if(this.state.activeRowId===0){   
            this.setState({activeRowId:rowId}); 
            document.getElementById('img-action-'+rowId).focus(); 
        }
        else if(this.state.activeRowId===rowId){ 
            this.setState({activeRowId:0}); 
        }
        else if(this.state.activeRowId!==rowId){   
            dropdown     = document.getElementById('dropdown-'+this.state.activeRowId);
            dropdownMenu = document.getElementById('dropdown-menu-'+this.state.activeRowId);
            dropdown.classList.toggle('show');
            dropdownMenu.classList.toggle('show');
            this.setState({activeRowId:rowId}); 
            document.getElementById('img-action-'+rowId).focus(); 
        }        
        
    }   
    
    onHideActionButtons = (event, rowId) =>{
        let dropdown     = document.getElementById('dropdown-'+rowId);
        let dropdownMenu = document.getElementById('dropdown-menu-'+rowId);
        dropdown.classList.remove('show');
        dropdownMenu.classList.remove('show');
        this.setState({activeRowId:0});
    }


    onSaveFormData = (id) =>{
        if(formValid(this.state)){
            let formErrors = this.state.formErrors;  
            let affiliate = '';
            let userGroupData = userGroupUrlCheck(this.props.location);
            let userGroup    = ''; 
            let grpProfileId = '';
            if(userGroupData!==undefined){
                userGroup = userGroupData.user_group; 
                grpProfileId = userGroupData.profile_id;
            }
            if(userGroup===LOGIN_AFFILIATE_GROUP){
                affiliate = grpProfileId;
            }
            if(id){            
                let otherExpData= {
                    id:id,
                    name: this.state.otherExpData.otherExpName, 
                    short_description: this.state.otherExpData.shortDescription, 
                    affiliate                     
                } 
                this.props.otherExpUpdateAction(otherExpData);   
            }else{          
                let otherExpData= {
                    name: this.state.otherExpData.otherExpName, 
                    short_description: this.state.otherExpData.shortDescription, 
                    affiliate                     
                } 
                this.props.otherExpAddAction(otherExpData);           
            }  
            this.setState({formErrors});          

        }else{
            let formErrors = this.state.formErrors;
            if(this.state.otherExpData.otherExpName==null){
                formErrors.otherExpName = MSG_REQUIRED;
            }            
            this.setState({formErrors});
        }
    }

    editBtnClick = (rowId) =>{  
        let formErrors = this.state.formErrors;
        formErrors.otherExpName = '';
        this.setState(formErrors);
        this.modal.current.handleOpenModal();
        this.props.otherExpEditAction(rowId);
    }

    deleteBtnClick = (rowId,name) =>{
        this.setState({
            otherExpData: {
                otherExpId: rowId,   
                otherExpName:name            
            }
        }); 
        this.modalDelete.current.handleOpenModal();
    }

    onDeleteAction = () =>{
        let otherExpId = this.state.otherExpData.otherExpId;
        this.props.otherExpDeleteAction(otherExpId);
        this.modalDelete.current.handleModelClose();              
    }

    onSort = (event,sortKey) =>{        
        let sOrder = '';
        if(this.state.sortField===sortKey){         
            sOrder = (this.state.sortOrder==='-') ? '' : '-';
            this.props.otherExpListAction({column:sOrder+this.state.sortField});
            this.setState({ sortOrder:sOrder });            
        }else{
            this.setState({ sortField:sortKey });
            this.props.otherExpListAction({column:this.state.sortOrder+sortKey});
        }        
    }    
    
    onCloseToast = () =>{
        this.setState({toastFlag:false,toastMessage:''});
    } 

    setToasterState(isEnabled,message,isSucces){
        this.setState({toastFlag:isEnabled,toastMessage:message,toastSuccess:isSucces});
        setTimeout(()=> {
            this.onCloseToast();
        }, 3000);
    }
  
    setStateUpdate(otherExp,status,activity,errorData){
        let formErrors = this.state.formErrors;
        if(activity===types.OTHER_EXP_ADD_SUCCESS){           
            this.modal.current.handleModelClose();
            this.props.otherExpListAction({column:this.state.sortOrder+this.state.sortField});
            this.setToasterState(true,MSG_OTHER_EXP_ADD_SUCCESS,true); 
        }else if(activity===types.OTHER_EXP_ADD_ERROR){ 
            if(status===400){
                if(errorData.hasOwnProperty('name')){
                    formErrors.otherExpName = MSG_OTHER_EXP_USED; // errorData.name[0];                
                }else{
                    this.modal.current.handleModelClose();
                    this.setToasterState(true,MSG_OTHER_SAVE_FAILED,false);
                }
                this.setState(formErrors);
            }else{
                this.modal.current.handleModelClose();
                if(errorData.hasOwnProperty('message')){ 
                    this.setToasterState(true,MSG_OTHER_SAVE_FAILED,false);
                }else{
                    this.setToasterState(true,MSG_OTHER_SAVE_FAILED,false);
                }      
            }    
        }else if(activity===types.OTHER_EXP_UPDATE_SUCCESS){            
            this.modal.current.handleModelClose();
            this.setToasterState(true,MSG_OTHER_EXP_UPDATE_SUCCESS,true);        
        }else if(activity===types.OTHER_EXP_UPDATE_ERROR){ 
            if(status===400){
                if(errorData.hasOwnProperty('name')){
                    formErrors.otherExpName = MSG_OTHER_EXP_USED;                
                }else{
                    this.modal.current.handleModelClose();
                    this.setToasterState(true,MSG_OTHER_SAVE_FAILED,false);
                }
                this.setState(formErrors);
            }else{
                this.modal.current.handleModelClose();
                if(errorData.hasOwnProperty('message')){ 
                    this.setToasterState(true,MSG_OTHER_SAVE_FAILED,false);
                }else{
                    this.setToasterState(true,MSG_OTHER_SAVE_FAILED,false);
                }      
            }           
        }else if(activity===types.OTHER_EXP_EDIT_SUCCESS){ 
            this.setState({
                otherExpData:{
                    otherExpId:otherExp.id,
                    otherExpName:otherExp.name,
                    shortDescription:otherExp.short_description
                }
            }, () => {
                if(document.getElementById('otherExpName')) {
                    document.getElementById('otherExpName').focus(); 
                }
            });       
        }else if(activity===types.OTHER_EXP_DELETE_SUCCESS){
      
            this.props.otherExpListAction({column:this.state.sortOrder+this.state.sortField});
             
            this.setToasterState(true,MSG_OTHER_EXP_DELETE_SUCCESS,true);
        }else if(activity===types.OTHER_EXP_DELETE_ERROR){
            let userGroupData = userGroupUrlCheck(this.props.location);
            let userGroup = ''; 
            if(userGroupData!==undefined){
                userGroup = userGroupData.user_group; 
            }   
            if(userGroup===LOGIN_AFFILIATE_GROUP){
                if(status===424){
                    this.setToasterState(true,MSG_OTHER_EXP_USED,false);
                }else{
                    this.setToasterState(true,MSG_OTHER_SAVE_FAILED,false); 
                }
            }else{
                this.setToasterState(true,MSG_OTHER_SAVE_FAILED,false);
            }
        }
    }
    
    componentDidUpdate(prevProps) {  
        const {otherExp,status,activity,errorData} = this.props;
        if (activity !== prevProps.activity) {
            this.setStateUpdate(otherExp,status,activity,errorData);
            this.props.clearAction();
        }else{
        }        
    }

    componentDidMount() {     
        const { location } = this.props;
        let userGroupData = userGroupUrlCheck(location);
        let userGroup = ''; 
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
        }   
        this.props.otherExpListAction({page:this.state.activePage,column:this.state.sortOrder+this.state.sortField});    
        document.title = LBL_APP_NAME+" - "+LBL_SETTINGS+" -  "+LBL_OTHER_EXPENSES;
        if(userGroup===LOGIN_AFFILIATE_GROUP){
            document.body.classList.add('body-affiliate'); 
        }
    }  

    render(){

        const {
            toastMessage,toastFlag,toastSuccess,otherExpData,sortField,sortOrder,           
        } = this.state

        const { otherExps,status} = this.props;
        
        let userGroupData = userGroupUrlCheck(this.props.location);
        let userGroup = ''; 
        let isAffiliate = false;
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
        }
        if(userGroup===LOGIN_AFFILIATE_GROUP){
            isAffiliate = true;
        }
        if(status===401 || status===403){
            if(userGroup===LOGIN_AFFILIATE_GROUP){
                return <Redirect to={ROUTE_AFFILIATE_REFRESH} />;
            }else{
                return <Redirect to={ROUTE_REFRESH} />;

            }
        }

        return(
            <div className="col-md-8">
                <Toast toastDescription={toastMessage} toastFlag={toastFlag} toastSuccess={toastSuccess} closeToast={this.onCloseToast} />
                <div className="box">
                    <div className="box-head">
                        <div className='divFloatLeft padding-left-20 padding-top-5 font-14'><Link to={userGroup===LOGIN_AFFILIATE_GROUP ? ROUTE_AFFILIATE_SETTINGS : ROUTE_SA_SETTINGS}>{LBL_BACK_TO_SETTINGS}</Link> </div>
                        <div className="to-right">                                   
                            <button className="btn btn-primary launch-modal" onClick={this.openModal.bind(this)}>{LBL_ADD_NEW}</button>
                        </div>
                    </div>
                    <div className="box-content">
                        <div className="table-responsive">
                            <table id="data-table-other-exp" className="table" style={{width:"100%"}} >
                                <thead>
                                    <tr>
                                    <th>{LBL_SLNUM}</th>
                                    <th onClick={(e) => this.onSort(e,'name')} className="spanPointer">{LBL_OTHER_EXPENSES} <i className={sortField=='name' ? getSortClass(1,sortOrder) : getSortClass()}></i></th>
                                        {isAffiliate && <th>{LBL_SHORT_DESCRIPTION}</th>}
                                        <th>{LBL_ACTIONS}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {(this.props.count===0) && 
                                    <tr>
                                        <td colSpan="6" className="text-center">{MSG_NOT_FOUND}</td>
                                    </tr>
                                }
                                {otherExps.map((item,index) => {
                                    return (
                                        <tr key={item.id}>
                                            <td>{index+1}</td>
                                            <td>{item.name}</td>
                                            {isAffiliate && <td>{item.short_description}</td>}
                                            <td>
                                            <div className="dropdown" id={'dropdown-'+item.id}>
                                                <button className="dropdown-toggle" type="button"
                                                    id={'dropdownMenuButton-'+item.id} data-toggle="dropdown"
                                                    aria-haspopup="true" onClick={(e) => this.onShowActionButtons(e, item.id)} >
                                                    <input type="image" id={"img-action-"+item.id} src={require('../../'+URL_IMG+'action.png')} alt="Action" onBlur={(e) => this.onHideActionButtons(e, item.id)} ></input>
                                                </button>
                                                <div className="dropdown-menu" id={'dropdown-menu-'+item.id}
                                                    aria-labelledby={'dropdownMenuButton-'+item.id}>
                                                    <Link className="dropdown-item edit" to="#" onMouseDown={(e) => this.editBtnClick(item.id)}>{LBL_EDIT}</Link>
                                                    <Link className="dropdown-item delete"
                                                        to="#" onMouseDown={(e)=>this.deleteBtnClick(item.id,item.name)}>{LBL_DELETE}</Link>
                                                </div>
                                            </div>
                                            </td>
                                        </tr>             
                                        
                                     )
                                  })      

                                }                
                                </tbody>
                            </table>
                            <div className="clear-b-scroll-sector">&nbsp;</div>
                            <div>&nbsp;</div>
                        </div>
                    </div>
                </div>

                <ModalWindow ref={this.modalDelete} header={LBL_CONFIRM_DELETE} type="delete" deleteItem={this.onDeleteAction} resetModalForm={this.onModalFormReset}>
                    {stringFormat(LBL_ARE_YOU_SURE_DELETE_OTHEXP,otherExpData.otherExpName)}
                </ModalWindow>


                <ModalWindow ref={this.modal} header={Number(this.state.otherExpData.otherExpId) > 0 ? "Edit "+LBL_OTHER_EXPENSES : "Add "+LBL_OTHER_EXPENSES} saveFormData={ (e)=>this.onSaveFormData(otherExpData.otherExpId)} resetModalForm={this.onModalFormReset} autoFocusField='otherExpName'>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <label>{LBL_OTHER_EXPENSES}</label>
                                <div className="text-input">
                                <input className={this.state.formErrors.otherExpName.length >0 ? "input-error" : ''} type="text" name="otherExpName" id="otherExpName" value={otherExpData.otherExpName || ''} onChange={this.onHandleChange} placeholder="" maxLength={120} />
                                    {this.state.formErrors.otherExpName.length>0 && this.state.formErrors.otherExpName!=MSG_REQUIRED && (
                                        <div className="text-red left-align text-12">{this.state.formErrors.otherExpName}</div>
                                    )} 
                                </div>
                            </div>
                        </div>
                    </div>
                    {isAffiliate && <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <label>{LBL_SHORT_DESCRIPTION}</label>
                                <div className="text-input">
                                <input className={this.state.formErrors.shortDescription.length >0 ? "input-error" : ''} type="text" name="shortDescription" id="shortDescription" value={otherExpData.shortDescription || ''} onChange={this.onHandleChange} placeholder="" maxLength={100} />
                                    {this.state.formErrors.shortDescription.length >0 && (
                                        <div className="text-red left-align text-12">{this.state.formErrors.shortDescription}</div>
                                    )} 
                                </div>
                            </div>
                        </div>
                    </div>}
                </ModalWindow>
            </div>
        )
        
    }
    
}
const mapStateToProps = (state) => {
    return {
        otherExps : state.otherExps.items,
        otherExp:state.otherExps.item,
        status:state.otherExps.status,
        activity:state.otherExps.activity,
        count:state.otherExps.count,
        errorData:state.otherExps.errorData
    }
}
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        otherExpListAction:otherExpListAction,  
        otherExpAddAction:data=>otherExpAddAction(data),
        otherExpEditAction:id=>otherExpEditAction(id),
        otherExpUpdateAction:data=>otherExpUpdateAction(data),
        otherExpDeleteAction:id=>otherExpDeleteAction(id),
        clearAction:clearAction
    },dispatch);
}
export default connect(mapStateToProps,mapDispatchToProps)(OtherExpensesComponent);